import { useMutation } from "@tanstack/react-query";

import fetchJSON from "../lib/reactQueryClient";
import { REACT_APP_GATEWAY_URL } from "../constants/constants";

export const TENANT_ID = "1";
export const PRODUCT_ID = "7";
export const ISD_CODE = "+91";

export const login = async ({ mobile, password }) => {
  const options = {
    method: "POST",
    headers: {
      platform: "web",
      "product-id": "1000",
      "tenant-id": TENANT_ID,
    },
    body: {
      admission_number: mobile,
      isd_code: ISD_CODE,
      phone: mobile,
      password,
      product_id: PRODUCT_ID,
      tenant_id: TENANT_ID,
    },
  };

  const response = await fetchJSON(
    `${REACT_APP_GATEWAY_URL}/api/v1/user/agents/login`,
    options,
  );

  return response;
};

export const useAuthentication = () => {
  return useMutation({
    mutationFn: login,
  });
};
